import { render, staticRenderFns } from "./CampaignGeneral.vue?vue&type=template&id=3b35955c&scoped=true&"
import script from "./CampaignGeneral.vue?vue&type=script&lang=ts&"
export * from "./CampaignGeneral.vue?vue&type=script&lang=ts&"
import style0 from "./CampaignGeneral.vue?vue&type=style&index=0&id=3b35955c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b35955c",
  null
  
)

export default component.exports